import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router-dom';
import { Row, Col, Glyphicon } from 'react-bootstrap';

import { IBefugnisListeResponse, IDienstleistungsListeResponse } from '../../models/ApiTypes';
import { UiStore } from '../../stores/UiStore';
import { inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import Befugnis from './Befugnis';
import Callout from '../site/Callout';

@observer
export default class Profile extends React.Component<RouteComponentProps<{}>, {}> {

  @inject(UiStore) uiStore: UiStore;
  @inject(ApiStore) apiStore: ApiStore;
  @observable befugnisse: IBefugnisListeResponse;
  @observable dienstleistungen: IDienstleistungsListeResponse;

  async componentDidMount() {
    this.uiStore.loadFreigaben();

    let befugnisse = await this.apiStore.befugnisse();
    if (befugnisse.ok) {
      this.setBefugnisse(befugnisse.json);
    }

    let dienstleistungen = await this.apiStore.dienstleistungen('');
    if (dienstleistungen.ok) {
      this.setDienstleistungen(dienstleistungen.json);
    }
  }

  @action setDienstleistungen(dienstleistungen: IDienstleistungsListeResponse) {
    this.dienstleistungen = dienstleistungen.sort((a, b)  => (a.kuerzel_dienstleistung.localeCompare(b.kuerzel_dienstleistung)));
  }

  @action setBefugnisse(befugnisse: IBefugnisListeResponse) {
    this.befugnisse = befugnisse.sort((a, b) => a.kuerzel.localeCompare(b.kuerzel));
  }

  render() {
    // Gefilterte Liste mit zum aktuellen Zeitpunkt gültigen Dienstleistungen erstellen
    let dienstleistungenAktiv = undefined;
    if (this.dienstleistungen) {
      dienstleistungenAktiv = this.dienstleistungen.filter(dienstleistung => dienstleistung.gueltig === true);
      let dldis: Array<string> = [];
      dienstleistungenAktiv.forEach(dienstleistung => { if (dldis.indexOf(dienstleistung.kuerzel_dienstleistung) === -1) {
        dldis.push(dienstleistung.kuerzel_dienstleistung);
      }});
      dienstleistungenAktiv = dldis;
    }
    return (
      <div className="maxwidth">
        <h2>Profil</h2>
        {!this.uiStore.userProfile ? <div className="maxwidth">lade Benutzerprofil...</div> : (
          <div>
            <Row>
              <Col md={3} xs={3}>Name</Col>
              <Col md={9} xs={9}>{this.uiStore.userProfile.anrede} {this.uiStore.userProfile.vorname} {this.uiStore.userProfile.nachname}</Col>
            </Row>

            <Row>
              <Col md={3} xs={3}>Benutzername</Col>
              <Col md={9} xs={9}>{this.uiStore.userProfile.username}</Col>
            </Row>

            <Row>
              <Col md={3} xs={3}>E-Mail</Col>
              <Col md={9} xs={9}>{this.uiStore.userProfile.email}</Col>
            </Row>

            <Row>
              <Col md={3} xs={3}>Kennung</Col>
              <Col md={9} xs={9}>{this.uiStore.userProfile.pinummer}</Col>
            </Row>
          </div>
        )}

        {this.uiStore.userProfile && this.uiStore.userProfile.portaladmin ? (<div><Glyphicon glyph="glyphicon glyphicon-user" /> <b>Portaladministrator</b></div>) : (null)}

        <h2>Auftraggeber</h2>
        {!this.uiStore.freigaben ? <div>lade Auftraggeber...</div> : this.uiStore.freigaben.map((freigabe, index) => (
          <div key={index}>{freigabe.name} ({freigabe.lizenznehmer})</div>
        ))}

        <h2>Befugnisse</h2>
        {!this.befugnisse ? <div>lade Befugnisse...</div> : this.befugnisse.map((befugnis, index) => (
          <Befugnis key={index} befugnis={befugnis} />
        ))}

        <h2>Dienstleistungen</h2>
        {dienstleistungenAktiv ?
          <div>
            {dienstleistungenAktiv.sort().map((dienstleistung, index) => (
              <div key={index}>
                {dienstleistung}
              </div>
            ))}
            {dienstleistungenAktiv.length === 0 && (
              <Callout bsStyle="warning">
                <p>Sie können aktuell keine Dienstleistungen anlegen, ggf. sind Ihre Befugnisse abgelaufen.<br/>Bitte wenden Sie sich bei Rückfragen an den <a href="/kontakt">Support</a> der DIQ Zert GmbH.</p>
              </Callout>
            )}
          </div>
          :
          <div>lade Daten</div>
        }
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/user/Profile.tsx